import React from 'react';
import { Typography } from 'antd';

const { Title } = Typography;

interface PageTitleProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  level?: 1 | 2 | 3 | 4 | 5;
  extra?: React.ReactNode;
}

export const PageTitle: React.FC<PageTitleProps> = ({ 
  title, 
  subtitle, 
  level = 2,
  extra,
}) => {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, marginBottom: subtitle ? 8 : 24 }}>
        <Title level={level} style={{ margin: 0 }}>
          {title}
        </Title>
        {extra && (
          <div>{extra}</div>
        )}
      </div>
      {subtitle && (
        <div style={{ marginBottom: 24 }}>
          {typeof subtitle === 'string' ? (
            <Typography.Text type="secondary" style={{ fontSize: 16, display: 'block' }}>
              {subtitle}
            </Typography.Text>
          ) : (
            subtitle
          )}
        </div>
      )}
    </>
  );
};